module.exports = __webpack_public_path__ + "assets/be6a897496b76e6ae8f9952064503bd5.png";